import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ProductPrice from '../../ProductPrice';
import AddToBasketButton from '../../AddToBasketButton';

import styles from './index.module.scss';

const BBInlineBasketCta = ({ productId }) => {
  const products = useSelector((state) => state.productsStorage.gifts);

  return (
    <div className={`bb ${styles['bb-inline-basket-cta']}`}>
      <div className={'container'}>
        <div className={styles['bb-inline-basket-cta__wrapper']}>
          <h1 className={styles['bb-inline-basket-cta__title']}>{products[productId].title}</h1>
          <div className={styles['bb-inline-basket-cta__price']}>
            <ProductPrice product={products[productId]} />
          </div>
          <div className={styles['bb-inline-basket-cta__cta']}>
            <AddToBasketButton product={products[productId]} isOutlined={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

BBInlineBasketCta.propTypes = {
  productId: PropTypes.number.isRequired,
};

export default BBInlineBasketCta;
